import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function clearLatestBatch(input: { id: number; batchId: number }) {
  const { id, batchId } = input
  return restApiClient
    .url(constructApiUrl(API.queues.clearLatestBatch.url, { id, batchId }))
    .delete()
}
